import moment from 'moment';

export default {   
    methods: {       
        dateTimeNow() {                        
            return moment().format("yyyy-MM-DDTHH:mm:ss");
        },
        addHours(date, hours) {            
            return moment(date).add(hours, 'hours').format("yyyy-MM-DDTHH:mm");
        },
        addDays(date, days) {
            return moment(date).add(days, 'days').format("yyyy-MM-DDTHH:mm");
        },
        shortDateToBackend(date) {
            return moment(date).format("yyyy-MM-DD");
        },
        getHour(date) {
            return moment(date).hour();
        }
       
    }
}
